import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Col, Input } from "reactstrap";
import { updateInput } from '../../../actions/action.pipeline-input';
import FileSelector from "../../../components/FileSelector/FileSelector";
import FormGroupCustom from "../../../components/Form/FormGroupCustom";
import InputCustom from '../../../components/Form/InputCustom';
import { TDispatch } from '../../../types/action';
import { IStore } from "../../../types/store";
import { IPipeline, TPipeline } from "../../../types/type.pipeline";
import { INPUT_SMALL } from "../../../utils/constants";

const Igblast = () => {
    const pipeline: IPipeline = useSelector((state: IStore) => state.pipeline);
    const { input, isAdvanced } = pipeline;
    const extensions = ['fasta', '.fasta', 'fa', '.fa', 'seq', '.seq'];
    const dispatch = useDispatch<TDispatch<TPipeline>>();

    const dispatchInput = (key: string, value: any) => dispatch(updateInput(key, value));

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const name = e.target.name;
        let value = e.target.value;

        dispatchInput(name, value);
    }

    return (
        <div className="igblast">
            <h4 className="subtitle">IgBlast</h4>
            <div className="pipeline-form">
                {/* input type nt or aa */}
                <FormGroupCustom
                    pipeline="igblast"
                    id="typeigblast"
                    input={input.type}
                    isAdvanced={isAdvanced}
                    row>
                    <Col sm={INPUT_SMALL}>
                        <InputCustom
                            type="select" name="type" id="input_type"
                            onChange={handleInput} value={input.type} defaultValue="1">
                            <option value="" disabled>Select Input Type</option>
                            <option value="1">NT</option>
                            <option value="2">AA</option>
                        </InputCustom>
                    </Col>
                </FormGroupCustom>

                {/* sequences */}
                <FormGroupCustom
                    pipeline="igblast"
                    id="inputigblast"
                    input={input.input}
                    isAdvanced={isAdvanced}
                    row>
                    <Col sm={INPUT_SMALL}>
                        <FileSelector
                            name="input"
                            tray={input.input}
                            accept={extensions}
                            isMultiple={true}
                            mixedExtension
                            // validateFilename={filterPattern}
                        />
                    </Col>
                </FormGroupCustom>

                {/* prefix */}
                <FormGroupCustom
                    pipeline="igblast"
                    id="prefixigblast"
                    input={input.prefix}
                    isAdvanced={isAdvanced}
                    row>
                    <Col sm={INPUT_SMALL}>
                        <Input
                            name="prefix"
                            id="igblast_prefix"
                            onChange={handleInput}
                            value={input.prefix}
                        />
                    </Col>
                </FormGroupCustom>
            </div>
        </div>
    )
}

export default Igblast;